import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import Styles from './Existing.css';

class ReactivateConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldResetPointBalance: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show) {
      this.setState({ shouldResetPointBalance: false });
    }
  }

  render() {
    return (
      <div>
        <Modal
          style={{ top: '120px' }}
          show={this.props.show}
          onHide={this._close}
          container={this}
          backdrop="static"
          dialogClassName={Styles['modal-dialog']}
        >
          <Modal.Header className={Styles['modal-header-normal']} closeButton>
            <Modal.Title style={{ fontSize: '19px', fontWeight: '300' }}>
              <div>Reactivate Loyalty Program?</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className={`${Styles['modal-body']} top20 `}
            style={{ marginLeft: '20px' }}
          >
            Are you sure you want to reactivate your loyalty program? It will
            run on all
            <br />
            your outlets immediately. <br />
            <div className="form-horizontal clearfix bottom20 top10">
              <div>
                <input
                  type="radio"
                  className={Styles['point-balance-radio']}
                  onClick={this._onClickResetPointBalanceYes}
                  name="radioGroup"
                  checked={this.state.shouldResetPointBalance}
                  id="ReactivateLoyaltyRadioLabel"
                />{' '}
                <label
                  for="ReactivateLoyaltyRadioLabel"
                  style={{ paddingLeft: '5px', fontWeight: '400' }}
                >
                  {' '}
                  Reset members' point balance?{' '}
                  <div
                    style={{
                      color: 'darkgray',
                      fontSize: '15px',
                      fontStyle: 'italic',
                    }}
                  >
                    Selecting this option will reset your members point balance
                    to 0<br />
                    Your member data will not be reset
                  </div>
                </label>
              </div>
            </div>
            <span className={Styles['modal-highlighted-message']}>
              Please notify all outlets and members before making this change.
            </span>
          </Modal.Body>
          <Modal.Footer style={{ marginTop: '20px' }}>
            <button
              type="button"
              style={{ width: '100px' }}
              className="btn btn-default"
              onClick={this._close}
            >
              Cancel
            </button>
            <button
              type="button"
              style={{ width: '150px' }}
              className="btn btn-primary"
              onClick={this._onClickReactivate}
            >
              Reactivate Program
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  _close = e => {
    e.stopPropagation();
    this.props.close();
  };

  _onClickReactivate = e => {
    e.stopPropagation();
    const data = {};
    if (this.state.shouldResetPointBalance) {
      data.reset = 'point';
    }
    this.props.confirm(data);
  };

  _onClickResetPointBalanceYes = () => {
    this.setState({
      shouldResetPointBalance: true,
    });
  };
}

ReactivateConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default ReactivateConfirmModal;
